import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const forWho = ['Mujeres solas con hijos que no pueden pagar una guardería para salir a trabajar.', 'Recién llegadas a USA que no tienen transporte propio ni licencia.', 'Personas sin estatus legal que necesitan ingresos rápidos y seguros en efectivo (Cash).', 'Cualquier mujer con sazón latina que necesite $500 extras a la semana.'];
  const notFor = ["Personas que buscan dinero 'mágico' sin cocinar ni esforzarse.", 'Quienes buscan un curso de alta cocina internacional o artesanal.', 'Personas que tienen miedo de enviar un mensaje de WhatsApp a sus vecinos.'];
  return <section className="bg-kitchen-cream py-12 md:py-20 px-5 md:px-12 lg:px-24" data-id="element-174">
      <div className="max-w-6xl mx-auto" data-id="element-175">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12" data-id="element-176">
          {/* Para ti si... */}
          <FadeIn data-id="element-177">
            <div className="bg-white p-5 md:p-10 rounded-3xl shadow-md border-t-8 border-kitchen-green" data-id="element-178">
              <h3 className="font-lora text-xl md:text-3xl font-bold text-kitchen-brown mb-5 md:mb-8 flex items-center gap-3" data-id="element-179">
                <span data-id="element-180">Esto ES para ti si...</span>{' '}
                <span className="text-2xl" data-id="element-181">👩‍🍳</span>
              </h3>
              <ul className="space-y-3 md:space-y-6" data-id="element-182">
                {forWho.map((item, index) => <li key={index} className="flex items-start gap-3 md:gap-4" data-id="element-183">
                    <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-kitchen-green flex-shrink-0 mt-0.5" data-id="element-184" />
                    <span className="font-nunito text-base md:text-lg text-kitchen-brown/90" data-id="element-185">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NO es para ti si... */}
          <FadeIn delay={0.2} data-id="element-186">
            <div className="bg-white p-5 md:p-10 rounded-3xl shadow-md border-t-8 border-kitchen-terracotta" data-id="element-187">
              <h3 className="font-lora text-xl md:text-3xl font-bold text-kitchen-brown mb-5 md:mb-8 flex items-center gap-3" data-id="element-188">
                <span data-id="element-189">Esto NO es para ti si...</span>{' '}
                <span className="text-2xl" data-id="element-190">🛑</span>
              </h3>
              <ul className="space-y-3 md:space-y-6" data-id="element-191">
                {notFor.map((item, index) => <li key={index} className="flex items-start gap-3 md:gap-4" data-id="element-192">
                    <XCircle className="w-5 h-5 md:w-6 md:h-6 text-kitchen-terracotta flex-shrink-0 mt-0.5" data-id="element-193" />
                    <span className="font-nunito text-base md:text-lg text-kitchen-brown/90" data-id="element-194">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}